import React, { useContext } from "react";
import { AppContext } from "../../App";
import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import './Footer.scss';
import i18n from '../i18n';
import PageComponents from "../cockpit/PageComponents";
import { Section } from "../cockpit";

const Footer = () => {
    const context = useContext(AppContext);
    const auth = useAuth();
    return <>{context && <>
        <div className="footer-top">
            <div className="thm-container">
                <div className="py-5 text-center">
                    <img src="assets/img/payment-icons.png" className="payment-icons" alt="" />
                </div>
            </div>
        </div>


        <footer className="site-footer pt-5">
            <PageComponents components={context.footer || []} />
            <div className="footer-bottom thm-container clearfix mt-5 pt-3 pb-5">
                <div className="pull-left copy-text" dangerouslySetInnerHTML={{ __html: context.copyright }}></div>
            </div>
        </footer>
    </>}
    </>
};

export default Footer;